<template lang="pug">
.input_container(:class="inputStatus", :style="{'width': width + 'px'}")
  .label {{ placeholder }}
  input.input(
      :type="type"
      :name="name"
      :autocomplete="autoCom"
      :disabled="disabled"
      :maxlength="maxlength"
      :readonly="inputStatus.focus ? false : 'readonly'"
      v-model="formValue"
      @focus="focusInput"
      @blur="blurInput"
      @change="changeInput"
      @keyup.enter="$emit('enter')"
  )
  i.suffix_icon(v-show="suffixIcon" :class="suffixIcon")
  p.input_info(v-if="tip") {{ tip }}
  slot
</template>

<script>
export default {
    name: 'LoginInput',
    props: {
        value: [String, Number],
        width: [String, Number],
        placeholder: String,
        tip: String,
        name: {
            type: String,
            required: false,
            default: ''
        },
        type: {
            type: String,
            required: false,
            default: 'text'
        },
        maxlength: {
            type: [String, Number],
            required: false,
            default: 100
        },
        suffixIcon: [String],
        disabled: Boolean,
        auto: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            inputStatus: {
                focus: false,
                hasValue: false
            }
        }
    },
    computed: {
        formValue: {
            get () {
                return this.value
            },
            set (nv) {
                this.$emit('input', nv)
            }
        },
        autoCom () { // 注册、修改密码等场景下禁用密码自动填充功能
            return this.auto || (this.type.toLowerCase() === 'password' ? 'new-password' : 'off')
        }
    },
    watch: {
        value: {
            immediate: true,
            handler (nv) {
                this.initStatus(nv)
            }
        }
    },
    created () {
        this.initStatus(this.value)
    },
    methods: {
        focusInput () {
            this.inputStatus.focus = true
        },
        blurInput () {
            this.inputStatus.focus = false
            this.$emit('handleBlur')
        },
        changeInput () {
            if(this.value) this.inputStatus.focus = true
        },
        initStatus (nv) {
            if (nv) {
                this.inputStatus.hasValue = true
            } else {
                this.inputStatus.hasValue = false
            }
        }
    }
}
</script>

<style type="text/css" lang="sass" scoped>
.input_container
    position: relative
    width: 360px
    height: 50px
    margin-bottom: 17px
    border-bottom: 1px solid #282729
    transition: border-color .5s
    .label
        position: absolute
        left: 0
        top: 23px
        font-size: 16px
        line-height: 22px
        pointer-events: none
        transition: all .5s
    .input
        width: 100%
        padding: 5px 0
        margin-top: 17px
        font-size: 16px
        line-height: 22px
        border: none 0
        &:disabled
            background-color: #fff !important
    .input_info
        position: absolute
        bottom: -19px
        left: 0
        color: #999
        font-size: 12px
        line-heihgt: 17px
    &.focus
        border-color: $main-color
    &.focus, &.hasValue
        .label
            top: 0
            color: #999
            font-size: 12px
            line-height: 17px
.suffix_icon
    position: absolute
    right: 0
    bottom: 5px
</style>
